"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _classnames = _interopRequireDefault(require("classnames"));

var _hover = require("../../hooks/hover");

var _default = function _default(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      popper = _ref.popper,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "onClick", "popper"]);

  var _useHover = (0, _hover.useHover)(),
      hovered = _useHover.hovered,
      targetProps = _useHover.targetProps;

  var isEnablePopper = !(0, _isNil["default"])(popper);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('px-4 py-2 hover:bg-secondary cursor-pointer select-none', className),
    onClick: onClick
  }, props, isEnablePopper ? targetProps : {}), children, isEnablePopper && hovered && popper);
};

exports["default"] = _default;
//# sourceMappingURL=LabelMenuAction.js.map